import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=5922b0e8&"
import script from "./Logout.vue?vue&type=script&charset=utf-8&lang=js&"
export * from "./Logout.vue?vue&type=script&charset=utf-8&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports